import { useState } from "react";
import { IconBell } from "@veto/ui";
import { ModalShell } from "./ModalShell";

/**
 * One-time sheet after the identity is created (phone parity, SEC-PUSH-004): notifications are
 * optional, and say nothing about who wrote or what unless previews are turned on.
 */
export function NotificationPrompt({
  onTurnOn,
  onNotNow,
}: {
  onTurnOn: () => Promise<void> | void;
  onNotNow: () => void;
}) {
  const [busy, setBusy] = useState(false);
  return (
    <ModalShell
      ariaLabel="Know when someone writes"
      onClose={() => {
        if (!busy) onNotNow();
      }}
      size="sheet"
      hideClose
      className="notify-prompt"
    >
      <div className="notify-prompt-body">
        <span className="notify-prompt-icon" aria-hidden>
          <IconBell size={30} />
        </span>
        <h2 className="notify-prompt-title">Know when someone writes</h2>
        <p className="muted">
          Notifications are optional. By default they only say &ldquo;New encrypted message&rdquo; —
          no name, no text — so nothing private shows on your screen. You can turn on previews later
          in Settings → Notifications.
        </p>
        <div className="notify-prompt-actions">
          <button
            type="button"
            className="btn"
            autoFocus
            disabled={busy}
            onClick={() => {
              setBusy(true);
              void Promise.resolve(onTurnOn()).finally(() => setBusy(false));
            }}
          >
            Turn on
          </button>
          <button type="button" className="btn secondary" disabled={busy} onClick={onNotNow}>
            Not now
          </button>
        </div>
      </div>
    </ModalShell>
  );
}
